import angular from 'angular';

import { routesConfig } from './appeals.routes';

export default angular.module('appeals', []).config(routesConfig);
